import { restRequest } from "vrcore-dashboard/dist/utilities";
export const JCENVIRO_GET_EWC_CODES = restRequest("JCENVIRO_GET_EWC_CODES");
export const JCENVIRO_ADD_EWC_CODE = restRequest(
    "JCENVIRO_ADD_WASTE_DISPOSAL_SITE"
);

export const JCENVIRO_REMOVE_EWC_CODE = restRequest(
    "JCENVIRO_REMOVE_WASTE_DISPOSAL_SITE"
);
